module.exports = __webpack_public_path__ + "static/media/18ECA13.d84daa38.jpg";